import { Exam } from "@examspark/types";

export interface ItemPosition {
  form: number;
  section: number;
  question: number;
}

type ExamWithContent = Pick<Exam, "content">;

export const getItemCount = (exam: ExamWithContent) => {
  return (
    exam.content?.forms?.[0]?.sections?.reduce(
      (acc, section) => acc + (section?.questionIds?.length ?? 0),
      0,
    ) ?? 0
  );
};

export const getItemCountInSection = (
  exam: ExamWithContent,
  position: Pick<ItemPosition, "form" | "section">,
) => {
  return (
    exam.content?.forms?.[position.form]?.sections?.[position.section]
      ?.questionIds?.length ?? 0
  );
};

export const getItemCountBefore = (
  exam: ExamWithContent,
  position: ItemPosition,
) => {
  const questionInEarlierSections =
    exam.content?.forms?.[position.form]?.sections?.reduce(
      (acc, section, sectionIdx) => {
        if (sectionIdx < position.section) {
          return acc + (section?.questionIds?.length ?? 0);
        }
        return acc;
      },
      0,
    ) ?? 0;

  return questionInEarlierSections + position.question;
};
